export default __webpack_public_path__ + "static/media/marron.001082ad.jpg";